<template>
	<div>
		<navigation msg="运营商/设备/货道管理" />
		<router-view />
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {
	
			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/oper/mac/aisle/home.vue